/**
 * Amplitude analytics events for the ttswtrs theme.
 */
;(function () {
  var body = document.querySelector('body');
  if (!body) return;
  var bodyData = body.dataset || {};
  var template = bodyData.template || '';


  var EVENTS_VERSION = '1.1.0';

  function ampReady() {
    return !!(window.is_amplitude_enabled && window.amplitude && typeof window.amplitude.track === 'function');
  }


  function ampTrack(eventName, props) {
    if (!ampReady()) return false;
    var payload = {};
    if (props && typeof props === 'object') {
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) payload[k] = props[k];
      }
    }
    payload.version = EVENTS_VERSION;
    try {
      window.amplitude.track(eventName, payload);
      return true;
    } catch (e) {
      try { if (window.console && console.warn) console.warn('[amplitude] track failed:', eventName, e); } catch (_) {}
      return false;
    }
  }


  function centsToPrice(v) {
    if (v == null || v === '') return null;
    var n = typeof v === 'number' ? v : parseFloat(v);
    if (!isFinite(n)) return null;
    return Math.round(n) / 100;
  }

  function getCurrency(fallback) {
    if (fallback) return fallback;
    if (bodyData.currency) return bodyData.currency;
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return '';
  }


  var TRYON_FLAG_KEY = 'dressx_try_on_completed';
  function hasCompletedTryOn() {
    try { return sessionStorage.getItem(TRYON_FLAG_KEY) === '1'; } catch (e) { return false; }
  }

 

  function getProductCollections() {
    var raw = bodyData.productCollections;
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (e) {}
    }
    try {
      var p = window.__DRESSX_TRYON_PARAMS;
      if (p && Array.isArray(p.product_collections) && p.product_collections.length) {
        return p.product_collections;
      }
    } catch (e) {}
    return null;
  }

  // ---------- page_view ----------
  ampTrack('page_view', {
    page_name: bodyData.pageName || template || 'page',
    signin: bodyData.signin === 'true'
  });

  // ---------- cart_viewed ----------
  if (template === 'cart') {
    ampTrack('cart_viewed', {
      signin: bodyData.signin === 'true',
      try_on_completed: hasCompletedTryOn()
    });
  }

  // ---------- product_viewed ----------
  if (template === 'product') {
    (function () {
      var ds = bodyData;
      var signinValue = ds.signin === 'true';
      var price = centsToPrice(ds.productPrice);
      var referrer = typeof document.referrer === 'string' ? document.referrer : '';
      var source = 'direct';
      try {
        if (referrer) {
          var refUrl = new URL(referrer);
          if (refUrl.origin === window.location.origin) {
            var path = (refUrl.pathname || '').toLowerCase();
            if (path.indexOf('/search') !== -1) source = 'search';
            else if (path.indexOf('/cart') !== -1) source = 'cart';
            else if (path.indexOf('/collections/') !== -1) source = 'collection';
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist';
            else if (path.indexOf('/account') !== -1) source = 'account';
            else if (path === '/' || path === '') source = 'home';
            else source = 'other';
          } else source = 'external';
        }
      } catch (e) {}
      var props = { signin: signinValue, try_on_completed: hasCompletedTryOn(), source: source };
      if (ds.productId) props.id = ds.productId;
      if (ds.productSku) props.sku = ds.productSku;
      if (price != null) {
        props.price = price;
        var curr = getCurrency();
        if (curr) props.currency = curr;
      }
      if (ds.productCategory) props.product_category = ds.productCategory;
      if (ds.productBrand) props.product_brand = ds.productBrand;
      var pvCollections = getProductCollections();
      if (pvCollections) props.product_collections = pvCollections;
      ampTrack('product_viewed', props);
    })();
  }


  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var btn = target.closest('button');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var action = String(form.action || form.getAttribute('action') || '');
      var hidden = null;
      try { hidden = form.querySelector('input[name="form_type"]'); } catch (er) {}
      var isLoginForm = action.indexOf('/account/login') !== -1 ||
                        (hidden && hidden.value === 'customer_login');
      if (!isLoginForm) return;
      try { sessionStorage.setItem('loginFormSubmitted', '1'); } catch (err) {}
    },
    true
  );
  // Also catch a native submit, just in case the form ever submits the standard way.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form) return;
      var action = String(form.action || form.getAttribute('action') || '');
      if (action.indexOf('/account/login') === -1) return;
      try { sessionStorage.setItem('loginFormSubmitted', '1'); } catch (err) {}
    },
    true
  );

  // ---------- login (account page after redirect) ----------
  if (template === 'account' || (bodyData.pageName || '').indexOf('account') !== -1) {
    var isLoginReferal = null;
    try { isLoginReferal = sessionStorage.getItem('loginFormSubmitted'); } catch (err) {}
    if (isLoginReferal) {
      var sent = ampTrack('login', { status: 'login successful' });
      if (sent) {
        try { sessionStorage.removeItem('loginFormSubmitted'); } catch (err) {}
      }
    }
  }


  function trackAddedToCart(item, cartCurrency) {
    if (!item) return;
    var signinValue = bodyData.signin === 'true';
    var price = centsToPrice(item.price);
    var props = {
      signin: signinValue,
      try_on_completed: hasCompletedTryOn()
    };
    if (item.id != null) props.id = item.id;
    if (item.sku != null) props.sku = item.sku;
    if (price != null) {
      props.price = price;
      var curr = getCurrency(cartCurrency);
      if (curr) props.currency = curr;
    }
    if (item.product_type != null) props.product_category = item.product_type;
    if (item.vendor != null) props.product_brand = item.vendor;
    var atcCollections = getProductCollections();
    if (atcCollections) props.product_collections = atcCollections;
    ampTrack('added_to_cart', props);
  }

  (function patchFetch() {
    if (typeof window.fetch !== 'function') return;
    var orig = window.fetch.bind(window);
    var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/i;
    var KLAVIYO_SUB_RE = /klaviyo\.com\/client\/subscriptions/i;

    window.fetch = function (input, init) {
      var urlStr = '';
      try {
        urlStr = typeof input === 'string'
          ? input
          : (input && (input.url || input.href || (input.toString && input.toString()))) || '';
      } catch (e) {}
      var method = String((init && init.method) ||
                          (input && input.method) || 'GET').toUpperCase();
      var isCartAdd = method === 'POST' && CART_ADD_RE.test(urlStr);
      var isKlaviyoSub = method === 'POST' && KLAVIYO_SUB_RE.test(urlStr);

      var p = orig.apply(this, arguments);
      if (!isCartAdd && !isKlaviyoSub) return p;

      return p.then(function (response) {
        try {
          if (isCartAdd && response && response.ok) {
            response.clone().json().then(function (data) {
              if (!data) return;
              // /cart/add returns the line item, /cart/add.js returns { items: [...] }.
              var item = (data && data.items && data.items[0]) || data;
              trackAddedToCart(item, '');
            }).catch(function () {});
          }
          if (isKlaviyoSub && response && (response.status === 202 || response.ok)) {
            ampTrack('email_submitted', { description: 'user submitted email' });
          }
        } catch (e) {}
        return response;
      });
    };
  })();


  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      var isNewsletter = false;
      try {
        if (form.matches('form.footer-subscribe__form')) isNewsletter = true;
        var hidden = form.querySelector && form.querySelector('input[name="contact[tags]"][value="newsletter"]');
        if (hidden) isNewsletter = true;
      } catch (er) {}
      if (!isNewsletter) return;
      ampTrack('email_submitted', { description: 'user submitted email' });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var submitter = e.submitter;
      var formAction = (form && (form.action || form.getAttribute('action'))) || '';
      var submitterName = submitter
        ? (submitter.name || submitter.getAttribute('name') || '')
        : '';
      var isCheckoutSubmit =
        form && formAction.indexOf('cart') !== -1 && submitterName === 'checkout';
      if (!isCheckoutSubmit) return;
      if (!ampReady()) return;
      e.preventDefault();
      var checkoutUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
        .replace(/\/?$/, '') + '/checkout';
      var cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js';
      fetch(cartUrl)
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var first = items[0];
          var price = centsToPrice(first && first.price);
          var props = { try_on_completed: hasCompletedTryOn() };
          if (first && first.id != null) props.id = first.id;
          if (first && first.sku != null) props.sku = first.sku;
          if (price != null) {
            props.price = price;
            var curr = getCurrency(cart && cart.currency);
            if (curr) props.currency = curr;
          }
          if (first && first.product_type != null) props.product_category = first.product_type;
          if (first && first.vendor != null) props.product_brand = first.vendor;
          ampTrack('checkout_started', props);
          setTimeout(function () { window.location.href = checkoutUrl; }, 150);
        })
        .catch(function () { window.location.href = checkoutUrl; });
    },
    true
  );

  var lastSearchOpenedAt = 0;
  function fireSearchOpened(triggerEl) {
    var now = Date.now();
    if (now - lastSearchOpenedAt < 800) return;
    var input = document.querySelector('#popup_search input[name="q"]');
    var query = (input && input.value) ? input.value.trim() : '';
    var source = 'drawer';
    if (triggerEl && triggerEl.closest) {
      var hostHeader = triggerEl.closest('header, .header, [id*="header"], [class*="header"]');
      var hostDrawer = triggerEl.closest('[id*="popup"], [class*="popup"]');
      if (hostDrawer) source = 'drawer';
      else if (hostHeader) source = 'header';
    }
    var sent = ampTrack('search_opened', {
      signin: bodyData.signin === 'true',
      query: query,
      source: source
    });
    if (sent) lastSearchOpenedAt = now;
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('.js-search-toggle, [data-search-toggle], [aria-controls="popup_search"]');
    if (!trigger) return;
    fireSearchOpened(trigger);
  }, true);
  var searchInputEl = document.querySelector('#popup_search input[name="q"]');
  if (searchInputEl) {
    searchInputEl.addEventListener('focus', function () { fireSearchOpened(searchInputEl); });
  }

  // ---------- size_selected (PDP) ----------

  if (template.indexOf('product') !== -1) {
    // size, sizes, taille, tailles, talla, tallas, tamanho, tamanhos,
    // gr\u00f6\u00dfe (groe), gr\u00f6ssen (grssen),
    // misura, misure,
    // \u0440\u0430\u0437\u043c\u0435\u0440 (??????), \u0440\u0430\u0437\u043c\u0435\u0440\u044b (???????),
    // \u30b5\u30a4\u30ba (???),
    // \uce58\uc218 (??),
    // \u5c3a\u7801 (??), \u5c3a\u5bf8 (??)
    var SIZE_LABEL_RE = new RegExp(
      '^(' +
        'size|sizes|' +
        'taille|tailles|' +
        'talla|tallas|' +
        'tamanho|tamanhos|' +
        'gr[o\u00f6]sse|gr[o\u00f6]ssen|gr\u00f6\u00dfe|' +
        'misura|misure|' +
        '\u0440\u0430\u0437\u043c\u0435\u0440|\u0440\u0430\u0437\u043c\u0435\u0440\u044b|' +
        '\u30b5\u30a4\u30ba|' +
        '\uce58\uc218|' +
        '\u5c3a\u7801|\u5c3a\u5bf8' +
      ')$',
      'i'
    );

    function isSizeSelect(select) {
      if (!select) return false;
      var name = select.getAttribute('name') || '';
      var m = name.match(/^options\[(.+?)\]$/i);
      if (!m) return false;
      var optionName = m[1];
      try { optionName = decodeURIComponent(optionName); } catch (e) {}
      return SIZE_LABEL_RE.test(optionName);
    }

    function findVariantForCurrentSelection() {
      try {
        var jsonEl = document.querySelector('.product-page_controls script[type="application/json"]');
        if (!jsonEl) return null;
        var variants = JSON.parse(jsonEl.textContent || '[]');
        var sels = document.querySelectorAll('.product-size select');
        var optionVals = [];
        for (var i = 0; i < sels.length; i++) {
          var v = sels[i].value;
          if (!v || v === 'blank' || v === 'related_product') return null;
          optionVals.push(v);
        }
        var title = optionVals.join(' / ');
        for (var j = 0; j < variants.length; j++) {
          if (variants[j] && variants[j].title === title) return variants[j];
        }
      } catch (e) {}
      return null;
    }


    var _lastSizeFire = { sel: null, value: '', at: 0 };
    function handleSizeSelect(select) {
      if (!isSizeSelect(select)) return;
      var v = select.value;
      if (!v || v === 'blank' || v === 'related_product') return;
      var now = Date.now();
      if (
        _lastSizeFire.sel === select &&
        _lastSizeFire.value === v &&
        now - _lastSizeFire.at < 400
      ) return;
      _lastSizeFire = { sel: select, value: v, at: now };
      var variant = findVariantForCurrentSelection();
      var price = variant ? centsToPrice(variant.price) : null;
      var props = { try_on_completed: hasCompletedTryOn() };
      if (variant && variant.id != null) props.id = variant.id;
      if (variant && variant.sku != null) props.sku = variant.sku;
      if (price != null) {
        props.price = price;
        var curr = getCurrency();
        if (curr) props.currency = curr;
      }
      if (bodyData.productCategory) props.product_category = bodyData.productCategory;
      if (bodyData.productBrand) props.product_brand = bodyData.productBrand;
      var ssCollections = getProductCollections();
      if (ssCollections) props.product_collections = ssCollections;
      ampTrack('size_selected', props);
    }

    function bindSizeSelects() {
      var sels = document.querySelectorAll('.product-size select');
      for (var i = 0; i < sels.length; i++) {
        var sel = sels[i];
        if (!sel.__amp_size_bound_native) {
          sel.__amp_size_bound_native = true;
          sel.addEventListener('change', function (ev) { handleSizeSelect(ev.target); });
        }

        if (!sel.__amp_size_bound_jq && typeof window.jQuery === 'function') {
          sel.__amp_size_bound_jq = true;
          try {
            window.jQuery(sel).on('change.ampSizeSelected', function () {
              handleSizeSelect(this);
            });
          } catch (e) {}
        }
      }
    }
    bindSizeSelects();

    var _bindAttempts = 0;
    var _bindTimer = setInterval(function () {
      _bindAttempts++;
      bindSizeSelects();
      if (_bindAttempts >= 10) clearInterval(_bindTimer);
    }, 500);
  }
})();
